import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth';

@Injectable({
  providedIn: 'root'
})
export class PublicGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(): boolean {
    if (this.authService.isAuthenticated()) {
      // Si ya está autenticado, redirigir al dashboard
      this.router.navigate(['/layout/dashboard']);
      return false;
    }
    // Si no está autenticado, permitir acceso al login
    return true;
  }
}
